import 'url-polyfill'

/**
 * 给定 url, 返回一个 window.URL 实例
 * @param url
 * @returns {*|URL}
 */
export function parseUrl(url) {
  if (url.startsWith('//')) {
    url = window.location.protocol + url
  }
  return new window.URL(url)
}

/**
* 获取url中的参数
* @param name 为参数名
* @param url 为获取参数的URL
*/
export function getUrlParam(name, url = window.location.href) {
  return parseUrl(url).searchParams.get(name)
}

/**
* 删除url中参数
* @param name 为参数名
* @returns {String}
*/
export function removeUrlParam(param, url = window.location.href) {
  const obj = parseUrl(url)
  obj.searchParams.delete(param)
  return obj.href
}

/**
* 增加url中的参数
* @param key
* @param value
* @param url
* @returns {String}
*/
export function addUrlParam(key, value, url = window.location.href) {
  const obj = parseUrl(url)
  obj.searchParams.set(key, value)
  return obj.href
}

/**
* 获取URL里domain
* 举例: url = "http://jira.yqxiu.cn/browse/REFACT-17"
* 返回 "jira.yqxiu.cn"
*/
export function getUrlHost(url = window.location.href) {
  return parseUrl(url).host
}

/**
* 返回url的pathName
* @param url
*/
export function getPathName(url = window.location.href) {
  const obj = parseUrl(url)
  return obj.pathname
}

/**
* 将dataURL转换为blob
* @param {*} dataURL
*/
export function dataURL2Blob(dataURL) {
  const arr = dataURL.split(',')
  const type = arr[0].match(/:(.*?);/)[1]
  const text = window.atob(arr[1]) // 将base64转换成文本
  let n = text.length
  const uint8Array = new Uint8Array(n)
  while (n > 0) {
    n -= 1
    uint8Array[n] = text.charCodeAt(n)
  }
  return new Blob([uint8Array], { type })
}

/**
* 将blob转换为dataURL
* @param {*} blob
*/
export function blob2DataURL(blob) {
  return new Promise(resolve => {
    const fileReader = new FileReader()
    fileReader.onload = e => resolve(e?.target?.result)
    fileReader.readAsDataURL(blob)
  })
}
